import { Route, Routes } from 'react-router-dom'
import { TableAnalysisPurchaseInvoices } from './table/table'


export const BrowserAnalysisPurchaseInvoices = () => {
    return (
        <Routes>
            <Route path={"/"} element={<TableAnalysisPurchaseInvoices />} />
        </Routes>
    )
}